<template>
  <div id="func-31-detalhe">
    <funcionalidade-header :titulo="tituloNavegacao"/>
    <div v-if="$route.query.idAutorizacao">
      <extrato-detalhe/>
    </div>
    <div v-if="$route.query.idOcorrencia || $route.query.idRegistro">
      <solicitacao-detalhe/>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoDetalhe from '@/components/TemplateSolicitacao/componentes/SolicitacaoDetalhe'
import ExtratoDetalhe from './components/ExtratoDetalhe'
import { mapState } from 'vuex'
export default {
  components: { SolicitacaoDetalhe, FuncionalidadeHeader, ExtratoDetalhe },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.textos.tituloTelaDetalhe
    }
  }
}
</script>
